<template>
  <div>
    <auto-fill-button @clicked="fillStepThreeForm" />
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(266, 'Contact information') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(267, 'Contact name')" />
      </template>
      <b-form-input
        v-model="dataToSend.contactName"
        :class="{ 'is-invalid': $v.dataToSend.contactName.$error }"
        :placeholder="FormMSG(1678, 'Enter name')"
        @keyup="handleInputChanged('dataToSend.contactName')"
      />
      <div v-if="$v.dataToSend.contactName.$error" class="invalid-feedback">
        {{ FormMSG(1679, 'Please enter name') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(268, 'Contact email')" />
      </template>
      <b-form-input
        v-model="dataToSend.contactEmail"
        :class="{ 'is-invalid': $v.dataToSend.contactEmail.$error }"
        :placeholder="FormMSG(1680, 'Enter contact email')"
        @keyup="handleInputChanged('dataToSend.contactEmail')"
      />
      <!-- <div v-if="!$v.dataToSend.contactEmail.required && getStateValidationField('dataToSend.contactEmail') !== null" class="invalid-feedback">
				{{ FormMSG(1681, 'Please enter contact email') }}
			</div> -->
      <div v-if="$v.dataToSend.contactEmail.$error" class="invalid-feedback">
        {{ FormMSG(1702, 'Please enter an email valid') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(269, 'Contact phone')" not-required />
      </template>
      <b-form-input v-model="dataToSend.contactPhone" :placeholder="FormMSG(1683, 'Enter contact phone')" />
    </b-form-group>

    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(256, 'Personal data') }}</h2>

    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(257, 'Country')" />
      </template>
      <v-select
        v-model="dataToSend.personalDataCountryKey"
        :options="countries"
        label="text"
        :clearable="false"
        :reduce="(option) => option.value"
        @input="getCountry"
      />
    </b-form-group>
    <VatChecker v-model="dataToSend.personalDataTva" @change="handleVatChange" />
    <google-auto-complete
      ref="step-three-google-search"
      :label="FormMSG(259, 'Internet search')"
      :put-search="searchAddress"
      :country="internetSearch"
      @placechanged="(item) => handleAutoComplete(item)"
    />
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(261, 'Company name')" />
      </template>
      <b-form-input
        v-model="dataToSend.personalDataCompanyName"
        :class="{ 'is-invalid': $v.dataToSend.personalDataCompanyName.$error }"
        :placeholder="FormMSG(1658, 'Enter company name')"
        @keyup="handleInputChanged('dataToSend.personalDataCompanyName')"
      />
      <div v-if="$v.dataToSend.personalDataCompanyName.$error" class="invalid-feedback">
        {{ FormMSG(1659, 'Please enter company name') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(262, 'Street')" />
      </template>
      <b-form-input
        v-model="dataToSend.personalDataStreet"
        :class="{ 'is-invalid': $v.dataToSend.personalDataStreet.$error }"
        :placeholder="FormMSG(1670, 'Enter street')"
        @keyup="handleInputChanged('dataToSend.personalDataStreet')"
      />
      <div v-if="$v.dataToSend.personalDataStreet.$error" class="invalid-feedback">
        {{ FormMSG(1671, 'Please enter street') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(263, 'Number')" />
      </template>
      <b-form-input
        v-model="dataToSend.personalDataNumber"
        :class="{ 'is-invalid': $v.dataToSend.personalDataNumber.$error }"
        :placeholder="FormMSG(1672, 'Enter number')"
        @keyup="handleInputChanged('dataToSend.personalDataNumber')"
      />
      <div v-if="$v.dataToSend.personalDataNumber.$error" class="invalid-feedback">
        {{ FormMSG(1673, 'Please enter number') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(264, 'Postal code')" />
      </template>
      <b-form-input
        v-model="dataToSend.personalDataZip"
        :class="{ 'is-invalid': $v.dataToSend.personalDataZip.$error }"
        :placeholder="FormMSG(1674, 'Enter postal code')"
        @keyup="handleInputChanged('dataToSend.personalDataZip')"
      />
      <div v-if="$v.dataToSend.personalDataZip.$error" class="invalid-feedback">
        {{ FormMSG(1675, 'Please enter postal code') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(265, 'City')" />
      </template>
      <b-form-input
        v-model="dataToSend.personalDataCity"
        :class="{ 'is-invalid': $v.dataToSend.personalDataCity.$error }"
        :placeholder="FormMSG(1676, 'Enter city')"
        @keyup="handleInputChanged('dataToSend.personalDataCity')"
      />
      <div v-if="$v.dataToSend.personalDataCity.$error" class="invalid-feedback">
        {{ FormMSG(1677, 'Please enter city') }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import CustomLabelMandatory from './CustomLabelMandatory.vue';
import { noTilde } from '~utils';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import GoogleAutoComplete from '@/components/GoogleAutoComplete';
import VatChecker from '@/components/VatChecker';
import AutoFillButton from './experimentals/AutoFillButton.vue';

export default {
  name: 'StepThreeForm',
  components: {
    CustomLabelMandatory,
    GoogleAutoComplete,
    VatChecker,
    AutoFillButton
  },
  mixins: [languageMessages, globalMixin, validationMixin],
  props: {
    isEnvDev: {
      type: Boolean,
      required: true
    },
    initData: { type: Object, default: () => {} }
  },
  data() {
    return {
      internetSearch: '',
      searchAddress: '',
      dataToSend: {
        personalDataCountryKey: 16965,
        personalDataTva: 0,
        personalDataCompanyName: null,
        personalDataStreet: null,
        personalDataNumber: null,
        personalDataZip: null,
        personalDataCity: null,
        contactName: null,
        contactEmail: null,
        contactPhone: ''
      }
    };
  },
  validations: {
    dataToSend: {
      personalDataCompanyName: { required },
      personalDataStreet: { required },
      personalDataNumber: { required },
      personalDataZip: { required },
      personalDataCity: { required },
      contactName: { required },
      contactEmail: { required, email }
    }
  },
  computed: {
    countries() {
      let countries = this.FormMenu(8);

      countries.sort((a, b) => {
        if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
          return -1;
        }
        if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
          return 1;
        }

        return 0;
      });

      return countries;
    }
  },
  watch: {
    initData: {
      handler(newVal) {
        this.dataToSend = newVal;
      },
      immediate: true
    },
    dataToSend: {
      handler(newVal) {
        this.$emit('step-three-form:change', { data: newVal });
      },
      deep: true
    }
  },
  methods: {
    generateData() {
      const randomFiller = this.generateRandomText(6).toLowerCase();
      const randomNumber = this.generateRandomNumber(6);
      return {
        personalDataCountryKey: 16965,
        personalDataTva: 21, // standard Belgian VAT %
        personalDataCompanyName: 'Dupont Consulting SPRL',
        personalDataStreet: 'Rue de la Loi',
        personalDataNumber: '16',
        personalDataZip: '1000',
        personalDataCity: 'Bruxelles',
        contactName: `Sophie Martin-${randomFiller}`,
        contactEmail: `sophiemartin.${randomFiller}+${randomNumber}@dupont-consulting.be`,
        contactPhone: '+3225556677' // Belgian landline format (+32 2...)
      };
    },
    fillStepThreeForm() {
      this.dataToSend = { ...this.generateData() };
      this.$v.$touch();
    },
    isInvalid() {
      this.$v.$touch();

      return this.$v.$invalid;
    },
    handleVatChange(vat) {
      this.dataToSend.personalDataCompanyName = vat.name;
      this.dataToSend.personalDataTva = vat.originVat;

      this.searchAddress = vat.address;
    },
    handleAutoComplete(addressData) {
      this.dataToSend.personalDataStreet = addressData.route || addressData.place.name;
      this.dataToSend.personalDataCity = addressData.locality;
      this.dataToSend.personalDataNumber = addressData.street_number || '';
      // const findCountry = this.countries.find((option) => option.text === addressData.country);
      // this.dataToSend.personalDataCountry = findCountry.value;
      // this.dataToSend.country = addressData.country;
      this.dataToSend.personalDataZip = addressData.postal_code;
    },
    getStateValidationField(field) {
      const customCond = `this.$v.${field}.$error === false`;
      if (eval(customCond)) {
        return null;
      }

      return false;
    },
    getCountry() {
      if (this.$refs['google-search-address']) {
        this.$refs['google-search-address'].clearSelected();
      }
    },
    handleInputChanged(elName) {
      this.$v.$touch();
      // console.log({ elName });
    }
  }
};
</script>
